import { useUrlStore } from '~/store/url'

export default defineNuxtPlugin((nuxtApp) => {
  const urlStore = useUrlStore()
  urlStore.selected.language = (nuxtApp?.$i18n as any)?.locale ?? 'en'
  nuxtApp.hook('i18n:beforeLocaleSwitch', ({ newLocale }) => {
    urlStore.selected.language = newLocale
  })
})
